<p-toast position="top-right" [pt]="{
    root: { class: 'w-full sm:w-96' },
    message: { class: 'mx-4 mt-4 backdrop-blur-xl bg-white/90 border border-slate-200/60 shadow-2xl rounded-2xl overflow-hidden' },
    messageContent: { class: 'flex items-start p-4 gap-3' },
    messageIcon: { class: 'text-2xl mt-0.5' },
    messageText: { class: 'flex-1' },
    summary: { class: 'font-bold text-slate-800 text-sm' },
    detail: { class: 'text-slate-500 text-xs mt-1 leading-relaxed' },
    closeButton: { class: 'w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors' }
  }" />
<router-outlet />